import { EExploreTabs } from 'components/Explore/ExploreTabs/helpers/constants';
import {
  ROUTE_DISCOVER_FEATURED,
  ROUTE_DISCOVER_FOLLOWING,
  ROUTE_DISCOVER_CHANNELS,
  ROUTE_DISCOVER_EVERYONE,
} from 'routes';

export const DISCOVER_DEFAULT_PATH = ROUTE_DISCOVER_FOLLOWING;
export const DISCOVER_DEFAULT_TAB = EExploreTabs.Following;

const PATH_TO_TAB: Record<string, EExploreTabs> = {
  [ROUTE_DISCOVER_FEATURED]: EExploreTabs.Featured,
  [ROUTE_DISCOVER_FOLLOWING]: EExploreTabs.Following,
  [ROUTE_DISCOVER_CHANNELS]: EExploreTabs.Channels,
  [ROUTE_DISCOVER_EVERYONE]: EExploreTabs.Everyone,
};

const TAB_TO_PATH: Record<EExploreTabs, string> = {
  [EExploreTabs.Featured]: ROUTE_DISCOVER_FEATURED,
  [EExploreTabs.Following]: ROUTE_DISCOVER_FOLLOWING,
  [EExploreTabs.Channels]: ROUTE_DISCOVER_CHANNELS,
  [EExploreTabs.Everyone]: ROUTE_DISCOVER_EVERYONE,
};

export const getTabFromPath = (pathname: string): EExploreTabs | null => PATH_TO_TAB[pathname] ?? null;

export const getPathForTab = (tab: EExploreTabs): string => TAB_TO_PATH[tab] ?? DISCOVER_DEFAULT_PATH;
